module.exports = __webpack_public_path__ + "img/no-emp-activity-hours.a361f306.webp";